import useJwt from '@core/auth/jwt/useJwt'
import axios from '@axios-ru'

const { jwt } = useJwt(axios, {
    storageTokenKeyName: 'accessTokenRu',
    storageRefreshTokenKeyName: 'refreshTokenRu',
})
export default jwt
